<template>
    <div class="container" style="padding-top: 1rem;" v-if="l">
        <div class="btn-hesd-container">
            <button class="btn btn-outline-secondary" @click="settings" style="margin-right: 5px;">
                <img src="../assets/3block.png" 
                    alt="yoda" 
                    title="yoda"
                    style="width: 30px;"
                >
            </button>
            <button class="btn btn-outline-danger" @click="exit">
                <img src="../assets/exit.png" 
                    alt="yoda" 
                    title="yoda"
                    style="width: 30px;"
                >
            </button>
        </div>
        <b-tabs content-class="mt-3">
            <b-tab title="Услуги" active>
                <ServicesAdmin />
            </b-tab>
            <b-tab title="Кейсы">
                <CaseAdmin />
            </b-tab>
        </b-tabs>

        <modal v-if="showSettings" @off="showSettings = false">
            <adminSettings @save="updateData" />
        </modal>
    </div>
</template>

<script>
import { store } from '../store.js';

import CaseAdmin from './case/CaseAdmin.vue';
import ServicesAdmin from './service/ServicesAdmin.vue';
import adminSettings from './adminSettings.vue';
import modal from './modal.vue';
import Data from '../API';
export default {
    components: {
        CaseAdmin,
        modal,
        ServicesAdmin,
        adminSettings
    },
    data() {
        return {
            showSettings: false
        }
    },
    methods: {
        updateData() {
            this.showSettings = false;
            Data.getStart()
                .then(json => {
                    store.getStart = json.data.data;
                })
        },
        settings() {
            this.showSettings = true;
        },
        exit() {
            localStorage.removeItem('token');
            this.$router.push('/');
        }
    },
    created() {
        if (!this.l) this.$router.push('/');
    },
    computed: {
        l() {
            return localStorage.getItem('token');
        }
    }
}
</script>

<style scoped>
    .btn-hesd-container {
        width: 100%;
        display: flex;
        justify-content: end;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminPage.vue